/** "Dr. Sarah Mitchell" → "SM" (moved from the mockup's mockData, Frontend §2.1). */
export const initials = (name: string): string =>
  name
    .replace(/^Dr\.\s*/, '')
    .split(/\s+/)
    .filter(Boolean)
    .map((s) => s[0])
    .slice(0, 2)
    .join('')
    .toUpperCase()
